import type { JSONValue } from "../models/Json";
import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export type BusinessSectorDTO = { name?: string; code?: string; description?: string | null } & Record<string, JSONValue>;
export const create = async (data: BusinessSectorDTO) => {
  return httpRequest.post("/prt/business_sector", data);
};

export const select = async (data: Record<string, JSONValue>) => {
  return httpRequest.get("/prt/business_sector/select", data);
};

export const get = async (id: string, data: Record<string, JSONValue>) => {
  return httpRequest.get(`/prt/business_sector/${id}`, data);
};
